const allConstants = {};

allConstants.urls = {
    UPLOAD: "https://backend.tahweel.com/uploads/",
    API: 'https://backend.tahweel.com/api'
}

export default allConstants;
